module.exports = __webpack_public_path__ + "static/GNY17-63199717988f979937edbc2231b2808d.jpg";